import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section className="py-16 lg:py-20" data-testid="final-cta-section"
              style={{ background: "linear-gradient(135deg, #082B20 0%, #0F3D2E 55%, #16305c 100%)" }}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
        <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-gold mb-3">VENTURAZ · POWERED BY CORPZO</div>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-[52px] leading-tight" style={{ color: "#f6f4ef" }}>
          Build trust before capital moves.
        </h2>
        <p className="mt-5 max-w-2xl mx-auto text-sm sm:text-base" style={{ color: "rgba(246,244,239,0.78)" }}>
          Whether you are raising capital or evaluating private opportunities, VENTURAZ gives both sides a more structured, verified, and diligence-led way to move forward.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/startup/apply"
            className="inline-flex items-center gap-2 bg-gold text-navy px-7 py-3 rounded-md font-heading font-semibold text-sm hover:bg-gold/90 transition-colors shadow-[0_10px_30px_rgba(212,175,55,0.25)]"
            data-testid="final-apply-funding"
          >
            Apply for Funding <ArrowRight size={16} />
          </Link>
          <Link
            to="/investor/join"
            className="inline-flex items-center gap-2 bg-white/[0.06] border border-white/15 text-cream px-7 py-3 rounded-md font-heading font-semibold text-sm hover:bg-white/[0.10] transition-colors"
            data-testid="final-join-investor"
          >
            Join as Investor
          </Link>
        </div>
        <div className="mt-8 text-[11px] font-mono uppercase tracking-[0.2em]" style={{ color: "rgba(246,244,239,0.55)" }}>
          <Link to="/sector-reports" className="hover:text-gold transition-colors inline-flex items-center gap-1.5" data-testid="final-sector-reports-link">
            Read the free monthly sector health report <ChevronRight size={12} />
          </Link>
        </div>
      </div>
    </section>
  );
}
